var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "ext1_1",
    cx: 20.6367,
    cy: 20,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext5_1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2471 1.40924C15.533 0.499926 18.0261 0 20.6361 0C31.6818 0 40.6361 8.9543 40.6361 20C40.6361 22.1238 40.305 24.1703 39.6917 26.0908C37.4058 27.0001 34.9127 27.5 32.3027 27.5C21.257 27.5 12.3027 18.5457 12.3027 7.5C12.3027 5.37617 12.6338 3.32965 13.2471 1.40924Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ext4_1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5922 18.6457C37.9174 17.0703 34.7996 16.1667 31.4707 16.1667C21.5296 16.1667 13.4707 24.2256 13.4707 34.1667C13.4707 35.8076 13.6903 37.3972 14.1016 38.9077C13.3215 38.6381 12.5632 38.3216 11.8302 37.9615C11.5943 36.7328 11.4707 35.4642 11.4707 34.1667C11.4707 23.121 20.425 14.1667 31.4707 14.1667C34.6312 14.1667 37.6205 14.8998 40.2778 16.2052C40.431 17.0029 40.5369 17.8174 40.5922 18.6457Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault7);
export default __webpack_public_path__ + "static/media/Default7.f4be88e5.svg";
export { ForwardRef as ReactComponent };